import {MessageCodes} from "../MessageCodes";
import Constants from "../Constants";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
import OutputError from "../OutputError";
import SuperText from "../SuperText";

const renderTWSEL = ({text, row, globalVariables}) => {
    const temp = row.data.map(x => parseFloat(x.diff))
    const max = Math.max(...(temp.filter(x => x > 0)))
    const min = Math.min(...(temp.filter(x => x < 0)))

    const start_cs = row?.start_cs
    const end_cs = row?.end_cs

    const getCSName = (cs_name, start, end) => {
        if(cs_name === start || cs_name === end)
            return (<>{cs_name}<SuperText text={'1'} /></>)

        return cs_name
    }

    return (
        <>
            <ResultText>
                {text}
                <EmptyLine />
            </ResultText>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell rowSpan={2} style={{verticalAlign: 'bottom', textAlign: 'left'}}>River Station</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'center'}} colSpan={3}>100yr WSEL (ft)</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'right'}}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'right'}}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'right'}}>Difference</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        (row.data).map(r => {
                            return (
                                <ResultRow>
                                    <ResultBodyCell style={{width: 125}}>
                                        <ComparisonCSName csName={getCSName(r.cross_section, start_cs, end_cs)} csNameVal={r.cross_section} />
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 120}}>{r.selected_yrex100_ws_elev}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 120}}>{r.target_yrex100_ws_elev}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 120}}>
                                        {
                                            ((parseFloat(r.diff) === min || parseFloat(r.diff) === max) && (ResultCellHighlight(null, r.diff))) || r.diff
                                        }
                                    </ResultBodyCell>
                                </ResultRow>
                            )
                        })
                    }
                </ResultBody>
            </ResultTable>
            <ResultText>
                <SuperText color={''} text={'1'} /> US/DS limit of the model.
            </ResultText>
        </>
    )
}

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.TWSEL000.error_id: {
            return renderTWSEL({
                row,
                globalVariables,
                text: `The 100yr WSEL comparison table between ${globalVariables?.sel_plan_title || 'base'} and ${globalVariables?.tar_plan_title || 'comparison'} plans is listed below.`
            })
        }
        case MessageCodes.Compare.WSEL001.error_id: {
            return renderTWSEL({
                row,
                globalVariables,
                text: `There are differences in the 100yr WSEL between ${globalVariables?.sel_plan_title || 'base'} and ${globalVariables?.tar_plan_title || 'comparison'} plans at the following ${row?.cs_count} cross sections. The tie-in stations are also listed with zero difference.`
            })
        }
        case MessageCodes.Compare.WSELICS001.error_id: {
            const temp = row.data.map(x => parseFloat(x.diff))
            const max = Math.max(...(temp.filter(x => x > 0)))
            const min = Math.min(...(temp.filter(x => x < 0)))

            return (
                <>
                    <ResultText>
                        There are differences in the 100yr WSEL between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plans at the following {row?.data?.length} Internal Bridge cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={2} style={{verticalAlign: 'bottom', textAlign: 'left'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center'}} colSpan={3}>100yr WSEL (ft)</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'right'}}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Difference</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                (row.data).map(r => {
                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{width: 125}}>
                                                <ComparisonCSName csName={r.cross_section} />
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 120}}>{r.selected_yrex100_ws_elev}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 120}}>{r.target_yrex100_ws_elev}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 120}}>
                                                {
                                                    ((parseFloat(r.diff) === min || parseFloat(r.diff) === max) && (ResultCellHighlight(null, r.diff))) || r.diff
                                                }
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.WSEL00.error_id: {
            return (
                <>
                    {
                        row?.data?.map(x => {
                            return (
                                <ResultText>
                                    There is no {x?.profile} profile in {x?.plan} plan, therefore {x?.profile} WSEL are not compared.
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Compare.C11_NOOUT01.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        case MessageCodes.Compare.C11_NOOUT02.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const C11 = {
    RenderDescription,
}